import typeControllerIsPresent from './typeControllerIsPresent'
import agentTypeOfCompanySelf from './agentTypeOfCompanySelf'
import isSelfSelected from './isSelfSelected'

export default {
  typeControllerIsPresent,
  agentTypeOfCompanySelf,
  isSelfSelected,
}
